/**
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/repository/conditions/DateConditionFilterMode
 */
export const DateConditionFilterMode = {
  DATA_INPUT: 'DATA_INPUT',
  STEPS: 'STEPS'
};
